import { StringUtils } from '@spotify/confidence-core-react';

import {
  EXPERIMENT_TYPES,
  type SearchResultItem,
} from '../../hooks/useResourceSearch';

const getExperimentStatusLabel = (
  workflowState: SearchResultItem['workflowState'],
): string | undefined => {
  if (!workflowState) return undefined;
  return StringUtils.capitalize(workflowState.state);
};

const FLAG_STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
};

interface ResourceStatusLabelProps {
  item: SearchResultItem;
}

export const ResourceStatusLabel = ({ item }: ResourceStatusLabelProps) => {
  let label: string | undefined;

  if (item.resourceType === 'flag') {
    label = item.state ? FLAG_STATUS_LABELS[item.state] : undefined;
  } else if (EXPERIMENT_TYPES.includes(item.resourceType)) {
    label = getExperimentStatusLabel(item.workflowState);
  }

  if (!label) return null;

  return <>{label}</>;
};
